export const STEPS = Object.freeze({
  MAIN: 'main',
  WORKSPACE: 'workspace',
  PROJECT: 'project',
  COURSEWARE: 'courseware',
  UNIT: 'unit',
});

